import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { TranslationAPI } from './services/api';
import './i18n'; // Initialize i18n
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import TranslatePage from './pages/TranslatePage';
import ResultsPage from './pages/ResultsPage';
import InstructionsPage from './pages/InstructionsPage';
import AboutPage from './pages/AboutPage';
import FAQPage from './pages/FAQPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  // Warm up the backend API when the app loads
  useEffect(() => {
    // Start warming up the backend service immediately
    // This runs in background and doesn't block the UI
    TranslationAPI.warmUpService().catch(() => {
      // Silently handle warm-up failures
      console.log('Background warm-up completed');
    });
  }, []);
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/instructions" element={<InstructionsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route 
              path="/translate" 
              element={
                <ProtectedRoute>
                  <TranslatePage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/results" 
              element={
                <ProtectedRoute>
                  <ResultsPage />
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;